<script lang="ts">
  import type { LeaderboardSkillsDetailsSkillItem, SkillCategory } from '$lib/api/types';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faPenToSquare } from '@itdev-fortawesome/pro-regular-svg-icons/faPenToSquare';
  import SkillBtn from '../common/SkillBtn.svelte';
  import BadgeGridItem from './BadgeGridItem.svelte';

  interface Props {
    classId: number;
    category: SkillCategory;
    leaderboardDetails: LeaderboardSkillsDetailsSkillItem[];
    onskillclicked: (s: LeaderboardSkillsDetailsSkillItem) => void;
  }

  let { classId, category, leaderboardDetails, onskillclicked }: Props = $props();
  const completedCount = leaderboardDetails.filter(x => x.completed).length;
</script>

<div id="category_{category.id}">
  <div class="d-flex align-items-center">
    <div class="flex-grow-1">
      <BadgeGridItem
        greyscaleOnIncomplete={true}
        horizontal
        small
        completedSkillCount={completedCount}
        possibleSkillCount={leaderboardDetails.length}
        {category}
      />
    </div>
    <a href="/classes/{classId}/log?categoryId={category.id}">
      <FontAwesomeIcon icon={faPenToSquare} class="me-2" />Log skills
    </a>
  </div>
  <h4 class="fs-6 border-bottom mt-3">Skills</h4>
  {#each leaderboardDetails as skill (skill.skillId)}
    <SkillBtn
      onclick={() => {
        onskillclicked(skill);
      }}
      name={skill.skillName}
      pointsValue={skill.pointsValue}
      withIcon
      isComplete={skill.completed}
    />
  {/each}
</div>
